// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"082a538a","51":"2e40f176","85":"5e9bc7c8","369":"4c4cdd1c","524":"2e286849","614":"5c4aeda2","697":"a0bb5424","899":"abe24418","928":"1c9dba2c","935":"d5bf0269"}[chunkId] + ".chunk.js";
};